import { Check } from "lucide-react";
import { STORE_CHIPS } from "@/lib/affiliate-ui";
import { cn } from "@/lib/utils";

interface StepPlataformasProps {
  readonly selected: readonly string[];
  readonly onChange: (next: readonly string[]) => void;
}

/** Passo 3: lojas em que a pessoa e afiliada (filtra o passo Credenciais). */
export function StepPlataformas({ selected, onChange }: StepPlataformasProps): JSX.Element {
  const toggle = (code: string): void => {
    onChange(selected.includes(code) ? selected.filter((c) => c !== code) : [...selected, code]);
  };

  return (
    <fieldset className="space-y-3">
      <legend className="text-sm text-muted-foreground">
        Marque as lojas em que você já tem conta de afiliado. No próximo passo pedimos só as credenciais delas.
      </legend>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {STORE_CHIPS.map((store) => {
          const active = selected.includes(store.code);
          return (
            <button
              key={store.code}
              type="button"
              role="checkbox"
              aria-checked={active}
              onClick={() => toggle(store.code)}
              className={cn(
                "flex min-h-11 items-center justify-between gap-3 rounded-lg border px-4 py-2.5 text-left text-sm font-medium transition-colors",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                active
                  ? "border-primary/50 bg-primary/10 text-foreground"
                  : "border-border bg-[hsl(var(--surface-raised)/0.4)] text-muted-foreground hover:text-foreground",
              )}
            >
              {store.label}
              <span
                className={cn(
                  "flex h-5 w-5 items-center justify-center rounded border",
                  active ? "border-primary bg-primary text-primary-foreground" : "border-border",
                )}
                aria-hidden="true"
              >
                {active && <Check size={13} />}
              </span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
